
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("gKkWD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8b8dedb8e7bd03e4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $8b8dedb8e7bd03e4$export$2e2bcd8739ae039 = {
    'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
    'cross_product_search_dialog.confluence.tab_label': 'Confluence',
    'cross_product_search_dialog.google_drive.tab_label': 'Schijf',
    'cross_product_search_dialog.google_drive.unauthenticated_prompt': "Je kunt aan al je Google-werkbladen, -documenten, -dia's en meer werken, zonder Atlassian ooit te verlaten. Alleen jij hebt die toegang.",
    'cross_product_search_dialog.jira.tab_label': 'Jira',
    'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
    'cross_product_search_dialog.recently_viewed_title': '{sectionTitle} onlangs bekeken',
    'cross_product_search_dialog.townsquare_globex_tab_label': 'Startpagina',
    'cross_product_search_dialog.townsquare_recent_goals': 'Recente doelen',
    'cross_product_search_dialog.townsquare_recent_help_links': 'Recente helplinks',
    'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions': "Recente inzichten, risico's en beslissingen",
    'cross_product_search_dialog.townsquare_recent_projects': 'Recente projecten',
    'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
    'cross_product_search_dialog.trello.tab_label': 'Trello',
    'cross_product_search_dialog.view_all_results_link': 'Alle {sectionTitle} bekijken',
    'extensible_search_dialog.advanced_search': 'Geavanceerd zoeken',
    'extensible_search_dialog.connect': 'Koppelen',
    'extensible_search_dialog.connect_to': 'Verbinden met',
    'global_search.jira.advanced_search_boards': 'Borden',
    'global_search.jira.advanced_search_filters': 'Filters',
    'global_search.jira.advanced_search_issues': 'Issues',
    'global_search.jira.advanced_search_label': 'Naar alle:',
    'global_search.jira.advanced_search_people': 'Personen',
    'global_search.jira.advanced_search_plans': 'Plannen',
    'global_search.jira.advanced_search_projects': 'Projecten',
    'global_search.jira.search_placeholder': 'Jira doorzoeken',
    'global_search.jira.search_placeholder_experiment_jsw_and_advanced_roadmaps_enabled': 'Zoek naar issues, borden, projecten, filters en plannen',
    'global_search.jira.search_placeholder_experiment_jsw_disabled': 'Zoek naar issues, projecten en filters',
    'global_search.jira.search_placeholder_experiment_jsw_enabled': 'Zoek naar issues, borden, projecten en filters',
    'product_s earch_dialog.confluence.assignee_filters_find_more': 'Een uitvoerder vinden',
    'product_search_dialog.atlas.search_input_expanded_placeholder': 'Atlas doorzoeken',
    'product_search_dialog.autocorrection.label': 'Bedoel je',
    'product_search_dialog.bitbucket.bitbucket_advanced_search': 'Code zoeken in {source}',
    'product_search_dialog.bitbucket.bitbucket_recent_repositories': "Onlangs bijgewerkte repository's",
    'product_search_dialog.bitbucket.bitbucket_repositories_section_title': "Repository's",
    'product_search_dialog.bitbucket.expanded.input-placeholder': 'Zoeken in Bitbucket',
    'product_search_dialog.bitbucket.repository_heading': "Repository's",
    'product_search_dialog.common.site_filters': 'Op site filteren',
    'product_search_dialog.compass.component_type.application': 'Applicatie',
    'product_search_dialog.compass.component_type.capability': 'Capaciteit',
    'product_search_dialog.compass.component_type.cloud_resource': 'Cloud-bron',
    'product_search_dialog.compass.component_type.data_pipeline': 'Gegevenspipeline',
    'product_search_dialog.compass.component_type.library': 'Bibliotheek',
    'product_search_dialog.compass.component_type.machine_learning_model': 'Model zelflerend systeem',
    'product_search_dialog.compass.component_type.other': 'Andere',
    'product_search_dialog.compass.component_type.service': 'Service',
    'product_search_dialog.compass.component_type.ui_element': 'UI-element',
    'product_search_dialog.compass.component_type.website': 'Website',
    'product_search_dialog.compass.components_section_heading': 'Componenten',
    'product_search_dialog.compass.expanded.input-placeholder': 'Zoeken in Compass',
    'product_search_dialog.compass.people_section_heading': 'Gebruikers',
    'product_search_dialog.compass.recently_viewed_components': 'Onlangs bekeken componenten',
    'product_search_dialog.compass.recently_viewed_teams': 'Onlangs bekeken teams',
    'product_search_dialog.compass.tab_label': 'Compass',
    'product_search_dialog.compass.teams_section_heading': 'Teams',
    'product_search_dialog.compass.upsell_modal_cta_text': 'Download Compass gratis',
    'product_search_dialog.compass.upsell_modal_description': "Catalogiseer je softwarearchitectuur op \xe9\xe9n plek, zodat teams die eraan werken het schakelen tussen contexten kunnen verminderen, sneller kunnen vinden wat ze nodig hebben en productiever kunnen zijn. Hoe vind je dat voor de ontwikkelaarservaring?",
    'product_search_dialog.compass.upsell_modal_heading': 'Houd de wildgroei van je software onder controle, zodat ontwikkelaars controle hebben over hun tijd',
    'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Meer informatie over Compass',
    'product_search_dialog.compass.upsell_modal_learn_more_link': 'Meer informatie',
    'product_search_dialog.compass.upsell_tab_title_lozenge': 'Nieuw',
    'product_search_dialog.compass.view_all_components_label': 'Alle componenten weergeven',
    'product_search_dialog.compass.view_all_results_label': 'Alle resultaten weergeven',
    'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Confluence geavanceerd zoeken',
    'product_search_dialog.confluence.clear_filters': 'Filters verwijderen',
    'product_search_dialog.confluence.content_section_heading': 'Content',
    'product_search_dialog.confluence.contributor_filters': 'Op bijdrager filteren',
    'product_search_dialog.confluence.contributor_filters_find_more': 'Vind een bijdrager',
    'product_search_dialog.confluence.date_filter_title': 'Voor het laatst bijgewerkt',
    'product_search_dialog.confluence.date_filter_today': 'Vandaag',
    'product_search_dialog.confluence.date_filter_yesterday': 'Gisteren',
    'product_search_dialog.confluence.date_filters_any': 'Elke tijd',
    'product_search_dialog.confluence.date_filters_month': 'Afgelopen 30 dagen',
    'product_search_dialog.confluence.date_filters_week': 'Afgelopen 7 dagen',
    'product_search_dialog.confluence.date_filters_year': 'Afgelopen jaar',
    'product_search_dialog.confluence.empty_state_body_no_advanced_search': 'Gebruik andere sleutelwoorden, of gebruik minder of meer algemene zoekwoorden',
    'product_search_dialog.confluence.empty_state_body_prequery_filters': 'We kunnen niets vinden dat in de afgelopen 90 dagen is aangemaakt of bijgewerkt met de door jou geselecteerde filters.',
    'product_search_dialog.confluence.empty_state_body_title': 'We hebben geen overeenkomsten gevonden voor je zoekopdracht.',
    'product_search_dialog.confluence.filters_applied': 'Het lijkt erop dat je een aantal filters hebt toegepast',
    'product_search_dialog.confluence.pages_blogs_attachments_section_heading': "Pagina's, blogs en bijlagen",
    'product_search_dialog.confluence.people_section_heading': 'Mensen',
    'product_search_dialog.confluence.search_input_expanded_placeholder': 'Doorzoek Confluence',
    'product_search_dialog.confluence.search_input_expanded_placeholder_ai': 'Zoek of stel vragen in je Confluence',
    'product_search_dialog.confluence.space_filters': 'Op space filteren',
    'product_search_dialog.confluence.space_filters_find_more': 'Vind een space',
    'product_search_dialog.confluence.spaces_section_heading': 'Spaces',
    'product_search_dialog.confluence.typing_state_header_text': 'Zoeken naar content in Confluence',
    'product_search_dialog.empty.no_results_body': 'Probeer het opnieuw met een andere term, of verfijn je resultaten met <a>Geavanceerd zoeken</a>',
    'product_search_dialog.empty.no_results_body_no_advanced_search': 'Probeer het opnieuw met een andere term',
    'product_search_dialog.empty.no_results_heading': 'We hebben geen overeenkomsten gevonden voor je zoekopdracht.',
    'product_search_dialog.empty_prequery.error_heading': 'Er is iets misgegaan bij het tonen van de eerste resultaten',
    'product_search_dialog.empty_prequery.no_results_heading': 'Zoek naar wat je nodig hebt',
    'product_search_dialog.error.failed_search_body': 'Dit is mogelijk gewoon een foutje. Het beste kun je het <a>nogmaals proberen.</a>',
    'product_search_dialog.error.failed_search_heading': 'Het lukt ons niet om te zoeken.',
    'product_search_dialog.give_feedback': 'Feedback geven',
    'product_search_dialog.google_drive.files_heading': 'Bestanden',
    'product_search_dialog.inline_onboarding_action': "Ok\xe9",
    'product_search_dialog.inline_onboarding_body': 'Gebruik de tabbladen Jira en Confluence om recente items op beide locaties te bekijken.',
    'product_search_dialog.inline_onboarding_title': 'Zoeken in Jira en Confluence',
    'product_search_dialog.jira.assignee_filters': 'Op uitvoerder filteren',
    'product_search_dialog.jira.boards_icon_accessibility_text': 'Pictogram bord',
    'product_search_dialog.jira.boards_projects_filters_plans_section_heading': 'Borden, projecten, filters en plannen',
    'product_search_dialog.jira.boards_projects_filters_section_heading': 'Borden, projecten en filters',
    'product_search_dialog.jira.date_filter_30': '30 d',
    'product_search_dialog.jira.date_filter_60': '60 d',
    'product_search_dialog.jira.date_filter_90': '90 d',
    'product_search_dialog.jira.date_filter_any': 'Elk moment',
    'product_search_dialog.jira.date_filter_past_30_days': 'Afgelopen 30 dagen',
    'product_search_dialog.jira.date_filter_past_7_days': 'Afgelopen 7 dagen',
    'product_search_dialog.jira.date_filter_past_year': 'Afgelopen jaar',
    'product_search_dialog.jira.date_filter_today': 'Vandaag',
    'product_search_dialog.jira.date_filter_yesterday': 'Gisteren',
    'product_search_dialog.jira.date_filters': 'Voor het laatst bijgewerkt',
    'product_search_dialog.jira.empty_prequery.no_results_heading': 'Begin met zoeken om je werk te vinden',
    'product_search_dialog.jira.issue_filter_done': 'Gereed',
    'product_search_dialog.jira.issue_filter_open': 'Bekijken',
    'product_search_dialog.jira.issue_filters': 'Filteren op status',
    'product_search_dialog.jira.issue_labels_filters': 'Filteren op label',
    'product_search_dialog.jira.issue_labels_filters_options_group_label': 'Alle labels',
    'product_search_dialog.jira.issue_labels_filters_placeholder': 'Label selecteren',
    'product_search_dialog.jira.issues_section_heading': 'Issues',
    'product_search_dialog.jira.jira_view_all_issues_new': 'Alle issues bekijken',
    'product_search_dialog.jira.project_filters': 'Op project filteren',
    'product_search_dialog.jira.project_filters_find_more': 'Een project vinden',
    'product_search_dialog.jira.projects_filters_section_heading': 'Projecten en filters',
    'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading': 'Recente borden, projecten, filters en plannen',
    'product_search_dialog.jira.recent_boards_projects_filters_section_heading': 'Recente borden, projecten en filters',
    'product_search_dialog.jira.recent_projects_filters_section_heading': 'Recente projecten en filters',
    'product_search_dialog.jira.recently_viewed_issues_section_heading': 'Onlangs bekeken issues',
    'product_search_dialog.jira.report_by_filters': 'Filteren op auteur',
    'product_search_dialog.jira.reported_by_me_filter': 'Door mij gerapporteerd',
    'product_search_dialog.jira.site_filters_find_more': 'Een site zoeken',
    'product_search_dialog.jira.view_all_issues': 'Geavanceerd issues zoeken',
    'product_search_dialog.loading_filters': 'Laden',
    'product_search_dialog.more_filters': 'Alle filters bekijken',
    'product_search_dialog.multi_site_advanced_search_label': 'Zoeken naar:',
    'product_search_dialog.multi_site_advanced_search_more_dropdown': '{count} meer',
    'product_search_dialog.no_options_filters': 'Geen opties',
    'product_search_dialog.opsgenie.advanced_search': 'Geavanceerd zoeken naar waarschuwingen',
    'product_search_dialog.opsgenie.alert_heading': 'Waarschuwingen',
    'product_search_dialog.opsgenie.expanded.input-placeholder': 'Opsgenie zoeken',
    'product_search_dialog.opsgenie.opsgenie_recent_alerts': 'Recente waarschuwingen',
    'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Vragen aan Atlassian Intelligence',
    'product_search_dialog.quick_find_confluence_space': 'Confluence-space',
    'product_search_dialog.quick_find_footer': 'Krijg je niet de gewenste resultaten? <btn>Feedback geven</btn>',
    'product_search_dialog.quick_find_no_content_body': 'Zoek of vraag naar alles wat je zoekt in je Atlassian-producten',
    'product_search_dialog.quick_find_no_content_header': 'Vind alles wat je zoekt',
    'product_search_dialog.quick_find_recent_search_text_dialog': 'Uit je recente zoekopdrachten',
    'product_search_dialog.quick_find_recent_spaces_additional_meta': 'Je bezocht onlangs',
    'product_search_dialog.quick_find_recently_viewed': 'Recent bekeken',
    'product_search_dialog.quick_find_result_item_team': 'Team',
    'product_search_dialog.quick_find_results_section': 'Zoekresultaten',
    'product_search_dialog.quick_find_search_input_placeholder': 'Zoek of vraag wat je wil',
    'product_search_dialog.quick_find_search_results': 'Zoekresultaten',
    'product_search_dialog.quick_find_show_all_results': 'Alle resultaten weergeven',
    'product_search_dialog.recent_spaces_section_heading': 'Recente spaces',
    'product_search_dialog.recently_viewed_heading': 'Geavanceerd zoeken',
    'product_search_dialog.recently_viewed_section_heading': 'Onlangs bekeken',
    'product_search_dialog.recently_worked_with_section_heading': 'Recent gewerkt met',
    'product_search_dialog.search_input_collapsed_placeholder': 'Zoeken',
    'product_search_dialog.search_people_link': 'Mensen zoeken',
    'product_search_dialog.show_all_results_link': 'Alle resultaten bekijken',
    'product_search_dialog.show_more_results_link': 'Meer tonen',
    'product_search_dialog.townsquare.search_input_expanded_placeholder': 'Zoeken op startpagina',
    'product_search_dialog.townsquare_goals_heading': 'Doelen',
    'product_search_dialog.townsquare_goals_view_all': 'Alle doelen doorzoeken',
    'product_search_dialog.townsquare_help_links_heading': 'Helplinks',
    'product_search_dialog.townsquare_learnings_risks_decisions_heading': "Inzichten, risico's en beslissingen",
    'product_search_dialog.townsquare_people_heading': 'Mensen',
    'product_search_dialog.townsquare_people_view_all': 'Alle personen doorzoeken',
    'product_search_dialog.townsquare_projects_heading': 'Projecten',
    'product_search_dialog.townsquare_projects_view_all': 'Alle projecten doorzoeken',
    'product_search_dialog.townsquare_recent_people': 'Recente personen',
    'product_search_dialog.townsquare_recent_topics': 'Recente onderwerpen',
    'product_search_dialog.townsquare_teams_heading': 'Teams',
    'product_search_dialog.townsquare_teams_view_all': 'Alle teams doorzoeken',
    'product_search_dialog.townsquare_topics_heading': 'Onderwerpen',
    'product_search_dialog.townsquare_topics_view_all': 'Alle onderwerpen doorzoeken',
    'product_search_dialog.trello.archived': 'Gearchiveerd',
    'product_search_dialog.trello.archived.card-hover': 'Deze kaart is gearchiveerd',
    'product_search_dialog.trello.board': 'Bord',
    'product_search_dialog.trello.boards_heading': 'Borden',
    'product_search_dialog.trello.cards_heading': 'Kaarten',
    'product_search_dialog.trello.closed': 'Gesloten',
    'product_search_dialog.trello.closed.board-hover': 'Dit bord is gesloten',
    'product_search_dialog.trello.expanded.input-placeholder': 'Zoeken in Trello',
    'product_search_dialog.trello.feedback_link': 'Help ons je zoekresultaten te verbeteren!',
    'product_search_dialog.trello.list': 'Lijst',
    'product_search_dialog.trello.private_workspace': "Priv\xe9workspace",
    'product_search_dialog.trello.recent_boards_heading': 'Recente borden',
    'product_search_dialog.trello.workspace': 'Workspace',
    'product_search_dialog.updated_date_formatter': 'Bijgewerkt op {date}',
    'search_dialog.filters.group.show-more': 'Meer tonen',
    'search_dialog.search_input_clear_label': 'Zoeksessie wissen',
    'search_dialog.search_input_exit_label': 'Zoeken afsluiten'
};

});


//# sourceMappingURL=nl.252d4300.js.map
